export const ROUTES = {
  HOME: `/`,
  FAQ: `/FAQ`,
  CONTACT_US: `/contact-us`,
  TOS: `/tos`,
  VIDEO_POLICY: `/video-policy`,
  PRIVACY_POLICY: `/privacy-policy`,
};
